import { EcobalyseAnalysisStatus } from "@tfg/types/schemas/enum"

import { i18n } from "~/i18n.ts"

export const ECOBALYSE_ANALYSIS_STATUS_TRANSLATIONS = {
  [EcobalyseAnalysisStatus.PENDING]: i18n.t("regulations:values.lca.pending"),
  [EcobalyseAnalysisStatus.ERROR]: i18n.t("regulations:values.lca.error"),
  [EcobalyseAnalysisStatus.SUCCESS]: i18n.t("regulations:values.lca.success"),
}
